// Set list of antagonisms.
export function SET_ANTAGONISM_TEST_LIST(state, antagonismTestsList) {
  state.antagonismTestsList = antagonismTestsList;
}
